

<label for="exampleInputEmail1"> Mapping </label>
<select class="custom-select" [(ngModel)]="selected_mapping_item" name="selected_mapping_item" (change)="Set_Selected_DeviceBehfa_Record()">
  <option value="">فاقد Mapping </option>
  <option *ngFor="let item of DataList_Mapping" value="{{item.title}}">{{item.dsc}}</option>

</select>